
namespace Gamification.Gamification {
    export class NodiColumns {
        static columnsKey = 'Gamification.Nodi';
    }
}